export availabilities from './availabilities/triggers';
export cancellationPolicy from './cancellation-policy/triggers';
export customer from './customer/triggers';
export inquiry from './inquiry/triggers';
export payment from './payment/triggers';
export rentalRuleset from './rental-ruleset/triggers';
export checkInOutRuleset from './check-in-out-ruleset/triggers';
export reservation from './reservation/triggers';



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/triggers.js